/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */

export type EnumsRegistrationStateCodes =
  (typeof EnumsRegistrationStateCodes)[keyof typeof EnumsRegistrationStateCodes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumsRegistrationStateCodes = {
  PREPARED: 'PREPARED',
  CREATED: 'CREATED',
  SIGNED: 'SIGNED',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  CLOSED: 'CLOSED'
} as const;
